export class TemperatureScales {
  static celsius: string = "Celsius";
  static fahrenheit: string = "Fahrenheit";
}


export class TemperatureConverter {
  static toCelsius(temperature: number): number {
    return parseFloat(((temperature - 32) * (5 / 9)).toFixed(2));
  }

  static toFahrenheit(temperature: number): number {
    return parseFloat(((temperature * 1.8) + 32).toFixed(2));
  }
}
export class TemperatureValueConverter {
  toView(value: number): number {

    let temperatureScale = localStorage.getItem("temperature-scale");
    if (!temperatureScale) {
      temperatureScale = TemperatureScales.fahrenheit;
    }

    switch (temperatureScale) {
      case TemperatureScales.celsius:
        return value;
      default:
        return TemperatureConverter.toFahrenheit(value);
    }

  }

  fromView(value: number): number {

    let temperatureScale = localStorage.getItem("temperature-scale");
    if (!temperatureScale) {
      temperatureScale = TemperatureScales.fahrenheit;
    }

    switch (temperatureScale) {
    case TemperatureScales.celsius:
      return value;
    default:
      return TemperatureConverter.toCelsius(value);
    }
  }
}

